The identifier for the `WebhookSubscription` that generated the requests.
